import React from "react";
import { Logo } from "./Logo";
import { NAV_LINKS } from "../../data/content";

export const Footer = ({ onBookCall }) => {
  const year = new Date().getFullYear();
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="relative border-t border-white/5 pt-24 pb-12 overflow-hidden" data-testid="footer">
      <div className="pointer-events-none absolute inset-0 section-glow" />
      <div className="relative container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-20 border-b border-white/5">
          <div className="lg:col-span-5">
            <Logo size={30} />
            <p className="mt-6 max-w-sm text-base leading-relaxed text-muted-foreground">
              Engineering-first, AI-native studio building intelligent software modern businesses can grow on.
            </p>
            <button
              onClick={onBookCall}
              data-testid="footer-book-call"
              className="mt-8 inline-flex items-center gap-2 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-white text-sm font-medium px-5 py-3 transition-colors"
            >
              Book a Discovery Call
            </button>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-6">Navigate</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button onClick={() => scrollTo(l.href)} className="text-sm text-white/70 hover:text-brand transition-colors">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-6">Company</div>
            <ul className="space-y-3">
              <li><button onClick={() => scrollTo("#founder")} className="text-sm text-white/70 hover:text-brand transition-colors">Founder</button></li>
              <li><button onClick={() => scrollTo("#products")} className="text-sm text-white/70 hover:text-brand transition-colors">Products</button></li>
              <li><button onClick={() => scrollTo("#contact")} className="text-sm text-white/70 hover:text-brand transition-colors">Contact</button></li>
            </ul>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="py-16 select-none">
          <div className="font-heading text-[22vw] leading-none font-light tracking-tighter text-white/[0.04] text-center">
            BuildRaq
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <span>© {year} BuildRaq. All rights reserved.</span>
          <span className="font-mono text-xs">Build the intelligence. Rack the structure.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
